import styled from '@emotion/styled';

import { Radio } from 'antd';

import colors from 'config/theme/colors';

export const RadioGroup = styled(Radio.Group)`
  padding: 2px;
  border-radius: 6px;
  height: 36px;
  background: ${colors['@switch-background']};

  .ant-radio-button-wrapper {
    /* No gap: Figma "File / Appointment / TabBar" (506:28669) has the three buttons adjacent —
       73 + 161 + 171 = 405, exactly the group's inner width. */
    border: 0;
    background: transparent;
    border-radius: 4px;
    font-weight: 500;
    color: ${colors['@text-color']};
    &:hover {
      opacity: 0.75;
    }
    &::before {
      display: none;
    }
    &-checked:not(.ant-radio-button-wrapper-disabled),
    &-checked {
      font-weight: 500;
      color: ${colors['@primary-color']} !important;
      background: ${colors['@switch-button-active']} !important;
      box-shadow: 0 3px 5px 0 rgba(219, 222, 225, 0.35);

      &::before {
        display: none;
      }
      &:hover {
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: 992px) {
    display: flex;
    .ant-radio-button-wrapper {
      > .ant-radio-button + span {
        white-space: nowrap;
      }
    }
  }

  @media screen and (max-width: 991px) {
    width: 100%;
    display: flex;
    height: auto;
    .ant-radio-button-wrapper {
      height: auto;
      width: inherit;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const WrapperAttachments = styled.div`
  h3 {
    font-weight: 600 !important;
    font-size: 18px;
    line-height: normal;
    color: ${colors['@text-color']} !important;
  }
`;
